// extracted by mini-css-extract-plugin
export default {"labelStyle":"PartsViewItemData_labelStyle__ZIoJX"};